module.exports = __webpack_public_path__ + "static/media/login-background.d26f6dab.jpg";